import _ from 'lodash';

import * as graphql from '@treams/treams-network';

function getChecklistItemProps(checklistItem: graphql.GoalChecklistItem) {
	const { type } = checklistItem.progress;

	const allowBounds = [
		graphql.GoalChecklistItemType.Range,
		graphql.GoalChecklistItemType.Currency,
	].includes(type);

	return [
		'id',
		'title',
		'description',
		'progress.value',
		'progress.type',
		'dueDate',
		'learningCourseID',
	].concat(allowBounds ? ['progress.lower', 'progress.upper'] : []);
}

export function toChecklistItemInput(
	checklistItem: graphql.GoalChecklistItem,
): graphql.UpdateGoalChecklistItemInput {
	return _.pick(
		checklistItem,
		getChecklistItemProps(checklistItem),
	) as graphql.UpdateGoalChecklistItemInput;
}
